<template>
    <div class="payment-create main-content">
      <div class="page-header">
        <h3 class="page-title">{{ $t('pos.completion_status') }}</h3>
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
            <router-link slot="item-title" to="/super-admin/dashboard" v-if="userType=='super_admin'">{{ $t('general.home') }}</router-link>
            <router-link slot="item-title" to="/supplier/dashboard" v-else-if="userType=='supplier'">{{ $t('general.home') }}</router-link>
            <router-link slot="item-title" to="/anchor/dashboard" v-else-if="userType=='anchor'">{{ $t('general.home') }}</router-link>
            </li>
            <li class="breadcrumb-item">
            <router-link slot="item-title" to="/super-admin/purchase-orders" v-if="userType=='super_admin'">{{ $tc('pos.po', 2) }}</router-link>
            <router-link slot="item-title" to="/supplier/purchase-orders" v-else-if="userType=='supplier'">{{ $tc('pos.po', 2) }}</router-link>
            <router-link slot="item-title" to="/anchor/purchase-orders" v-else-if="userType=='anchor'">{{ $tc('pos.po', 2) }}</router-link>
            </li>
            <li class="breadcrumb-item">{{ $t('pos.completion_status') }}</li>
        </ol>
      </div> 
      <SinglePurchaseOrderRow :fetchData="fetchData" />
      <table-component
        ref="table"
        :data="itemStatus"
        :show-filter="false"
        table-class="table"
      >
      <table-column
          :label="$t('items.name')"
          show="name"
        />
        <table-column
          :label="$t('items.part_number')"
          show="part_number"
        />
        <table-column
          :label="$t('items.unit')"
          show="unit_name"
        />
        <table-column
          :label="$t('items.price')"
          show="price"
        >
          <template slot-scope="row">
            <span> {{ $t('items.price') }} </span>
            <div v-html="$utils.formatMoney(row.price, defaultCurrency)" />
          </template>
        </table-column>
        
        <table-column
          :label="$t('items.quantity')"
          show="quantity"
        >
            <template slot-scope="row">
                <span> {{ $t('items.quantity') }} </span>
                <div v-html="row.quantity" />
            </template>
        </table-column>
        <table-column
          :label="$t('items.delivered_quantity')"
          show="delivered_quantity"
        >
            <template slot-scope="row">
                <span> {{ $t('items.delivered_quantity') }} </span>
                <div v-html="row.deliveryQuantity" />
            </template>
        </table-column>
        

        <table-column
          :label="$t('items.remaining_quantity')"
          show="deliveryNote_remainig_quantity"
        />
      </table-component>
  </div>
    
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
import SinglePurchaseOrderRow from './SinglePurchaseOrderRow'
const { required, between, maxLength, numeric } = require('vuelidate/lib/validators')
export default {
    components: { MultiSelect ,SinglePurchaseOrderRow
     },
    mixins: [validationMixin],
    data () {
    return {
      userType:null,
      fetchData:[],
      actionRecord:[],
      isLoading: false,
      invoiceUniqueHash:'',
      itemStatus:[],
    }
  },
  computed:{
    ...mapGetters('currency', [
      'defaultCurrency'
    ]),
  },
  created(){
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';

    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }
    // this.loadData()  
    this.loadPO()
  },
  methods: {
    ...mapActions('po', [
      'fetchPO',
      'SinglePOArray'
    ]),
    
    async loadData(){
        
    },
    async loadPO () {
      let response = await this.SinglePOArray(this.$route.params.id)
      if (response.data) {
        this.fetchData =response.data.purchaseOrder
        this.itemStatus = response.data.purchaseOrder[0].items
      }
    },
  } 
}
</script>
<style scoped>
.table-component{
  min-height: 0px !important;
}
</style>